import Route from '@ember/routing/route';
import { ADMIN_POSTINGS_CONTROLLER } from 'sh-www/controllers/admin/postings';

const DEFAULT_QUERY_PARAMS = [
  ...Object.values(ADMIN_POSTINGS_CONTROLLER.FILTERS),
  'page',
  'sort',
  'sortOrder',
].reduce((accum, param) => {
  accum[param] = { refreshModel: true, replace: true };
  return accum;
}, { });

class AdminPostingsRoute extends Route {
  queryParams = DEFAULT_QUERY_PARAMS;

  /** @inheritDoc */
  model() {
    return {
      postings: null,
    };
  }

  /** @inheritDoc */
  setupController(controller) {
    super.setupController(...arguments);

    controller.loadPostings.perform();
  }

  /** @inheritDoc */
  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.loadPostings.cancelAll();
    }
  }
}

export default AdminPostingsRoute;
